import React from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import AdminPanel from 'views/adminPanel/AdminPanel';
import BasicLayout from '../Layouts/BasicLayout/BasicLayout';
import Layout from '../Layouts/Layout';

const Router: React.FC = () => (
  <BrowserRouter>
    <Switch>
      <Route path={['', '/']} exact>
        <Layout layout={BasicLayout} isPublic>
          <Route path="/" exact component={() => <AdminPanel />} />
        </Layout>
      </Route>
      <Route component={() => <div>404</div>} />
    </Switch>
  </BrowserRouter>
);
export default Router;
